import * as React from 'react'
import MenuBar from './containers/MenuBar'
import { Grid, Segment, Label, Icon } from 'semantic-ui-react'
import InfoPage from './containers/InfoPage'
import { Switch } from 'react-router-dom'
import Deposit from './containers/Deposit'
import AuthRoute from '../../../../core/AuthRoute'
import { PageType } from '../../../../enums'
import { connect } from 'react-redux'
import './User.css'

type RollItemStoreProps = {
  isLoggedIn: boolean,
  userInfo: IUser,
}

class User extends React.Component<RollItemStoreProps> {

  render() {
    return (
      <Segment className="user-container" style={{width: '90%', margin: 'auto'}}>
        <Label>
          <Icon name="user"/>
          Chào {this.props.userInfo.username}
        </Label><br/><br/><br/>
        <Grid stackable={true} columns={2} padded={true}>
          <Grid.Row>
            <Grid.Column width={3}>
              <MenuBar/>
            </Grid.Column>
            <Grid.Column width={12}>
              <Switch>
                <AuthRoute path={'/user/info'} component={InfoPage} pageType={PageType.USER}/>
                <AuthRoute path={'/user/depositBank'} component={Deposit} pageType={PageType.USER}/>
              </Switch>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    )
  }
}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
  ...ownProps,
  loggedIn: state.loggedIn,
  userInfo: state.root.userInfo,
})
export default connect(mapStateToProps)(User)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/User/User.tsx